module.exports = __webpack_public_path__ + "static/mongo-definitive-guide-05b84e17ccec99ef2c1fceb139fde6af.jpg";